import { Theme } from 'themes/interfaces';
import { createTheme } from '@mui/material/styles';

export const defaultTheme = (theme: Theme) => createTheme({
  direction: "ltr",
  palette: {
    mode: "light",
    common: {
      black: theme.color.black,
      white: theme.color.white
    },
    primary: {
      main: theme.color.accent.color,
      contrastText: theme.color.accent.text
    },
    secondary: {
      main: theme.color.secondary.color,
      contrastText: theme.color.secondary.text
    },
    error: {
      main: theme.color.status.error.color,
      contrastText: theme.color.status.error.text
    },
    warning: {
      main: theme.color.status.warning.color,
      contrastText: theme.color.status.warning.text
    },
    success: {
      main: theme.color.status.success.color,
      contrastText: theme.color.status.success.text
    },
    text: {
      primary: theme.palette.font.color,
      secondary: theme.palette.font.accent,
      disabled: theme.color.disabled.color
    },
    divider: theme.palette.border,
    background: {
      default: theme.palette.background.color
    }
  },
  typography: {
    htmlFontSize: 16,
    fontFamily: "\"Space Grotesk\", sans-serif",
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    h1: {
      fontFamily: "\"Space Grotesk\", sans-serif",
      fontWeight: 300,
      fontSize: "6rem",
      lineHeight: 1.167,
      letterSpacing: "-0.01562em"
    },
    h2: {
      fontFamily: "\"Space Grotesk\", sans-serif",
      fontWeight: 300,
      fontSize: "3.75rem",
      lineHeight: 1.2,
      letterSpacing: "-0.00833em"
    },
    h3: {
      fontFamily: "\"Space Grotesk\", sans-serif",
      fontWeight: 400,
      fontSize: "3rem",
      lineHeight: 1.167,
      letterSpacing: "0em"
    },
    h4: {
      fontFamily: "\"Space Grotesk\", sans-serif",
      fontWeight: 400,
      fontSize: "2.125rem",
      lineHeight: 1.235,
      letterSpacing: "0.00735em"
    },
    h5: {
      fontFamily: "\"Space Grotesk\", sans-serif",
      fontWeight: 400,
      fontSize: "1.5rem",
      lineHeight: 1.334,
      letterSpacing: "0em"
    },
    h6: {
      fontFamily: "\"Space Grotesk\", sans-serif",
      fontWeight: 500,
      fontSize: "1.25rem",
      lineHeight: 1.6,
      letterSpacing: "0.0075em"
    },
    subtitle1: {
      fontFamily: "\"Space Grotesk\", sans-serif",
      fontWeight: 400,
      fontSize: "1rem",
      lineHeight: 1.75,
      letterSpacing: "0.00938em"
    },
    subtitle2: {
      fontFamily: "\"Space Grotesk\", sans-serif",
      fontWeight: 500,
      fontSize: "0.875rem",
      lineHeight: 1.57,
      letterSpacing: "0.00714em"
    },
    body1: {
      fontFamily: "\"Space Grotesk\", sans-serif",
      fontWeight: 400,
      fontSize: "1rem",
      lineHeight: 1.5,
      letterSpacing: "0.00938em"
    },
    body2: {
      fontFamily: "\"Space Grotesk\", sans-serif",
      fontWeight: 400,
      fontSize: "0.875rem",
      lineHeight: 1.43,
      letterSpacing: "0.01071em"
    },
    button: {
      fontFamily: "\"Space Grotesk\", sans-serif",
      fontWeight: 500,
      fontSize: "0.875rem",
      lineHeight: 1.75,
      letterSpacing: "0.02857em",
      textTransform: "uppercase"
    },
    caption: {
      fontFamily: "\"Space Grotesk\", sans-serif",
      fontWeight: 400,
      fontSize: "0.75rem",
      lineHeight: 1.66,
      letterSpacing: "0.03333em"
    },
    overline: {
      fontFamily: "\"Space Grotesk\", sans-serif",
      fontWeight: 400,
      fontSize: "0.75rem",
      lineHeight: 2.66,
      letterSpacing: "0.08333em",
      textTransform: "uppercase"
    }
  }
})